import { platformDetails } from "../../core/utils/platformDetails"
import NotFoundScreen from "../../screen/NotFoundScreen"

const NotFoundContainer = () => {
  const { platformName, platformLogo } = platformDetails()

  return <NotFoundScreen {...{ platformName, platformLogo }} />
}

export default NotFoundContainer
